import { SettingsOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import { themeColors } from 'colors';

/** Slightly under full {@link PageHeader} h4 icon slot (2.5rem); keeps the gear visible without matching the title size. */
const DEFAULT_ICON_REM = '2.125rem';

/** Smaller gear for role builder / dense title rows (avoid `fontSize="inherit"` from a parent h4). */
const COMPACT_ICON_REM = '1.125rem';

export type SettingsSectionHeaderIconProps = {
    /** Smaller gear for role builder / dense title rows. */
    compact?: boolean;
};

/** Gear icon for settings-area headers ({@link SettingsPageLayout} / related screens). */
const SettingsSectionHeaderIcon = ({ compact = false }: SettingsSectionHeaderIconProps) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: themeColors.settingsPage.sectionHeaderIcon,
            lineHeight: 1,
        }}
    >
        <SettingsOutlined
            sx={{
                color: 'currentColor',
                display: 'block',
                fontSize: compact ? COMPACT_ICON_REM : DEFAULT_ICON_REM,
            }}
        />
    </Box>
);

export default SettingsSectionHeaderIcon;
